/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ProjectSettingsServiceDeskSlaSettingsType from '@jira/spa-apps__project-settings-service-desk-sla-settings/src/ServiceDeskSlaSettingsPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskSlaSettings: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ProjectSettingsServiceDeskSlaSettingsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-service-desk-sla-settings", jiraSpaEntry: "async-project-settings-service-desk-sla-settings" */ '@jira/spa-apps__project-settings-service-desk-sla-settings/src/ServiceDeskSlaSettingsPage.tsx'
			),
		),
	);

export const ServiceDeskSlaSettings = (): React.JSX.Element => (
	<UFOSegment name="project-settings-service-desk-sla-settings">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskSlaSettings}
			pageId="project-settings-service-desk-sla-settings"
			shouldShowSpinner
		/>
	</UFOSegment>
);
